import { dataHooks } from '../../../libs/dataHooks';

export const searchDataHooks = dataHooks<{
  input: {};
  dropdown: {};
  label: {};
  closeButton: {};
}>('search');
